import { render, staticRenderFns } from "./scheduleDetails.vue?vue&type=template&id=9884bbb0&scoped=true&"
import script from "./scheduleDetails.vue?vue&type=script&lang=js&"
export * from "./scheduleDetails.vue?vue&type=script&lang=js&"
import style0 from "./scheduleDetails.vue?vue&type=style&index=0&id=9884bbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9884bbb0",
  null
  
)

export default component.exports